if (!customElements.get('overwatch-video')) {
  customElements.define('overwatch-video', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const button = this.querySelector('button[data-video-src]');
      if (!button) return;
      button.addEventListener('click', () => {
        const url = new URL(button.dataset.videoSrc);
        if (url.protocol !== 'https:' || url.hostname !== 'www.youtube.com' || !url.pathname.startsWith('/embed/')) return;
        url.searchParams.set('autoplay', '1');
        const iframe = document.createElement('iframe');
        iframe.src = url.href;
        iframe.title = 'How the Overwatch academy works';
        iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        iframe.allowFullscreen = true;
        iframe.referrerPolicy = 'strict-origin-when-cross-origin';
        iframe.tabIndex = 0;
        this.replaceChildren(iframe);
        iframe.focus();
      }, { once: true });
    }
  });
}
